<template>
    <!-- 2. Page Search START -->
    <div id="Search">
        <div id="accordion" class="split split-switch" v-bind:class="{'split-switch-size':isWide}">
            <div class="split-item split-left">
                <div class="split-left-inner split-inner" style="background:#226296">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="#">Home</a></li>
                            <li class="breadcrumb-item">検索結果</li>
                        </ol>
                    </nav>
                    <div class="inner-box">
                        <div class="search-bg">{{getMessage}}</div>
    
                        <div class="dictionary-wrap times-new-roman">
                            <div class="dictionary">
    
                                <transition name="slide">
                                    <div id="list1" :key="wordData.vid" class="collapse dictionary-in" v-bind:class="{'show':isMessage}" aria-labelledby="headingOne" data-parent="#accordion">
    
                                        <ul class="detail-name">
                                            <li>
                                                <span class="flag" v-bind:style="{background:wordData.color}">
                                                     {{wordData.dicshotname}} 
                                                  </span>
                                                <span class="name1">{{wordData.word1}}</span>
                                                <span class="name2">{{wordData.examples}}</span>
                                            </li>
                                            <li class="size-switch-wrap">
                                                <div class="size-switch">
                                                    <div v-show="!isSearchBox && !isCompView" class="btn-group" role="group" aria-label="Basic example">
                                                        <button type="button" class="btn btn-secondary size-switch-left" @click="chgWide">
                                                            <span class="icon-left">
                                                                <i class="material-icons">arrow_back</i>
                                                                元に戻す
                                                            </span>
                                                            <span class="icon-right">
                                                                画面を広げる
                                                                <i class="material-icons">arrow_forward</i>
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <ul class="detail-list">
                                            <li class="voice-icon" v-if="wordData.vfname_m_url!=='a' && wordData.vfname_f_url!=='a'">
                                                <ul>
                                                    <li class="icon1" v-show="wordData.vfname_m_url!==''">
                                                        <a href="#" @click="soundPlay(wordData.vfname_m_url)">
                                                            <img :src="ojiImage" />
                                                        </a>
                                                    </li>
                                                    <li class="icon2" v-show="wordData.vfname_f_url!==''">
                                                        <a href="#" @click="soundPlay(wordData.vfname_f_url)">
                                                            <img :src="obaImage" />
                                                        </a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li class="detail-phoneme">
                                                <div class="font2">{{wordData.phoneme1}}</div>
                                                <span class="font3" style="font-size: 0.9em;" v-for="(row_part, index) in wordData.disp_part_names" :key="index">
                                                    【{{row_part}}】
                                                </span>
                                            </li>
                                            <li class="detail-mean">
                                                <div v-if="wordData.categoryname!=''">意味分野：{{wordData.categoryname}}</div>
                                                <div v-if="wordData.word2!=''">原著かな：{{wordData.word2}}</div>
                                                <div v-if="wordData.phoneme2!=''">原著音韻：{{wordData.phoneme2}}</div>
                                            </li>
                                        </ul>
    
                                        <div class="detail-jp">
                                            <span v-for="(jplang, index) in wordData.jplang" :key="index" >
                                                <span v-show="index!=0 && jplang.word_kanji!=''">、</span><span v-bind:class="{bold:isWordBold(jplang.word_kanji)}">{{jplang.word_kanji}}</span>
                                            </span>
                                        </div>
    
                                        <div class="card-body">
                                            <div class="details">
    
    
                                                <div class="details-example" v-for="(meaning , index) in wordData.meaning" :key="index">
                                                    <div class="detail-part" v-show="meaning.disp_meaning_title_flg=='1'">
                                                        <ul>
                                                            <!-- li>{{meaning.partname}}&nbsp;{{meaning.subpartname}}&nbsp;{{wordData.inflectionname}}&nbsp;{{wordData.subinflectionname}}</li -->
                                                            <li>{{meaning.disp_part_subpart}}</li>
                                                            <li class="-last">原著&nbsp;{{meaning.dpartname}}&nbsp;{{wordData.dinflectionname}}</li>
                                                        </ul>
                                                    </div>
    
                                                    <div class="text">
                                                        {{meaning.meaning}}
                                                    </div>
                                                    <div class="block-details">
                                                        <div class="block-details-box">
                                                            <table class="table table-details-example">
                                                                <tr v-for="(example, index) in meaning.example" :key="index">
                                                                    <td class="voice-icon-wrap">
                                                                        <div class="voice-icon">
                                                                            <ul>
                                                                                <li class="icon1" v-show="example.vfname_m_url!==''">
                                                                                    <a href="#" @click="soundPlay(example.vfname_m_url)">
                                                                                        <img :src="ojiImage" />
                                                                                    </a>
                                                                                </li>
                                                                                <li class="icon2" v-show="example.vfname_f_url!==''">
                                                                                    <a href="#" @click="soundPlay(example.vfname_f_url)">
                                                                                        <img :src="obaImage" />
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="text-area">
                                                                            {{example.diarect}}
                                                                            <p class="font2">
                                                                                {{example.phoneme}}
                                                                            </p>
                                                                            <p class="text">
                                                                                {{example.common}}
                                                                            </p>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
    
    
                                                <div class="details-reference">
                                                    <div class="tit2">参考</div>
                                                    <div class="text">
                                                        {{wordData.reference}}
                                                    </div>
                                                </div>
                                                <div class="clearfix">
                                                    <div class="details-image">
                                                        <img :src="ipath" alt="写真">
                                                    </div>
                                                </div>
    
    
    
    
    
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="split-item split-right">
                <div class="split-right-inner split-inner box-col">
                    <div class="inner-box">
    
                        <div v-show="isListTypeJp">
                            <div class="search-tit-wrap wa">
                                <ul>
                                    <li>
                                        <h2 class="search-tit mb0">
                                            <span class="left">
                                          <span class="badge badge-pill badge-custom custom1">和琉</span> 検索結果：
                                            </span>
                                            <span class="right">{{jpSearchWord}}</span>
                                        </h2>
                                    </li>
                                    <li class="count">
                                        <span class="badge badge-primary badge-count">{{pageCurrentNo}}/{{pageAllCnt}} 全:{{allCnt}}件</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="list-wrap">
                                <div class="card list" v-for="(item , index) in jpListData" :key="index" v-bind:class="{current:isSelectVid(item.stwordid)}">
                                    <div class="card-header">
                                        <ul class="list-header">
                                            <li>
                                                <a class="list-anker"  @click="clickItemJ(item)">
                                                    <span>
                                                        {{item.kana_kanji}}  {{item.st_partname}} {{item.word1}}
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <span class="list-text text2">{{item.inflectionname}}</span>
                                                <span v-if="item.categoryname!='' && item.inflectionname!=''">/</span>
                                                <span class="list-text text2">{{item.categoryname}}</span>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" class="" data-toggle="modal" data-target="#page1" @click="clickComp(item.vid)">
                                                    <span class="moadl-icon">比較する</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="card-body">
                                        <table class="w-100" style="line-height: 1;">
                                            <tr>
                                                <td>
                                                    <span class="flag" v-bind:style="{background:item.color}">
                                                     {{item.dicshotname}} 
                                                  </span>
    
                                                    <span class="list-text">
                                                     {{item.meaning}} 
                                                  </span>
                                                </td>
                                                <td>
                                                    <div class="voice-icon-list">
                                                        <ul>
                                                            <li class="icon1" v-show="item.main_m_flg==='1'">
                                                                <a href="#" @click="soundPlay(item.main_m_file)">
                                                                    <img :src="ojiImage" />
                                                                </a>
                                                            </li>
                                                            <li class="icon2" v-show="item.main_f_flg==='1'">
                                                                <a href="#" @click="soundPlay(item.main_f_file)">
                                                                    <img :src="obaImage" />
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
    
                                <paginate :value="pageCurrentNo" :page-count="pageAllCnt" :page-range="5" :margin-pages="2" :click-handler="cb" :prev-text="'Prev'" :next-text="'Next'" :next-class="'next'" :prev-class="'prev'" :container-class="'pager'" :page-class="'page-item'">
                                </paginate>
    
    
    
    
                            </div>
                        </div>
    
                        <div v-show="isListTypeRy">
                            <div class="search-tit-wrap">
                                <ul>
                                    <li>
                                        <h2 class="search-tit mb0">
                                            <span class="left">
                                              <span class="badge badge-pill badge-custom custom2">琉和</span> 検索結果：
                                            </span>
                                            <span class="right">{{jpSearchWord}}</span>
                                        </h2>
                                    </li>
                                    <li class="count">
                                        <span class="badge badge-primary badge-count">{{pageCurrentNo}}/{{pageAllCnt}} 全:{{allCnt}}件</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="list-wrap">
                                <div class="card list" v-for="(item , index) in jpListData" :key="index" v-bind:class="{current:isSelectVid(item.vid)}">
                                    <div class="card-header">
                                        <ul class="list-header">
                                            <li>
                                                <a class="list-anker" @click="clickItem(item)">
                                                    <span>
                                                        <span style="font-family: Times New Roman">{{item.word1}}</span> {{item.partname}}
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <span class="list-text text2">{{item.inflectionname}}</span>
                                                <span v-if="item.categoryname!='' && item.inflectionname!=''">/</span>
                                                <span class="list-text text2">{{item.categoryname}}</span>
                                            </li>
                                            <li>
                                                <a href="#" class="" data-toggle="modal" data-target="#page1" @click="clickComp(item.vid)">
                                                    <span class="moadl-icon">比較する.</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="card-body">
                                        <table class="w-100" style="line-height: 1;">
                                            <tr>
                                                <td>
                                                    <span class="flag" v-bind:style="{background:item.color}">
                                                     {{item.dicshotname}} 
                                                  </span>
    
                                                    <span class="list-text">
                                                    {{item.meaning}} 
                                                  </span>
                                                </td>
                                                <td>
                                                    <div class="voice-icon-list">
                                                        <ul>
                                                            <li class="icon1" v-show="item.main_m_flg==='1'">
                                                                <a href="#" @click="soundPlay(item.main_m_file)">
                                                                    <img :src="ojiImage" />
                                                                </a>
                                                            </li>
                                                            <li class="icon2" v-show="item.main_f_flg==='1'">
                                                                <a href="#" @click="soundPlay(item.main_f_file)">
                                                                    <img :src="obaImage" />
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
    
    
    
    
    
    
    
                                <paginate :value="pageCurrentNo" :page-count="pageAllCnt" :page-range="5" :margin-pages="2" :click-handler="cb" :prev-text="'Prev'" :next-text="'Next'" :next-class="'next'" :prev-class="'prev'" :container-class="'pager'" :page-class="'page-item'">
                                </paginate>
    
    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- home END -->
</template>

<style lang="css">
.voice-icon-list .icon1 {
    background: url("../assets/img/illust-oji-play.gif") no-repeat;
    background-size: 20px;
}

.voice-icon-list .icon1 a {
    display: inline-block;
}

.voice-icon-list .icon1 a:hover img {
    visibility: hidden;
}

.voice-icon-list .icon2 {
    background: url("../assets/img/illust-oba-play.gif") no-repeat;
    background-size: 22px;
}

.voice-icon-list .icon2 a {
    display: inline-block;
}

.voice-icon-list .icon2 a:hover img {
    visibility: hidden;
}

.voice-icon .icon1 {
    background: url("../assets/img/illust-oji-play.gif") no-repeat;
    background-size: 30px;
}

.voice-icon .icon1 a {
    display: inline-block;
}

.voice-icon .icon1 a:hover img {
    visibility: hidden;
}

.voice-icon .icon2 {
    background: url("../assets/img/illust-oba-play.gif") no-repeat;
    background-size: 33px;
}

.voice-icon .icon2 a {
    display: inline-block;
}

.voice-icon .icon2 a:hover img {
    visibility: hidden;
}

.pager {
    overflow: hidden;
    margin: 10px;
}

.pager li {
    margin: 0 1px;
    position: relative;
    float: left;
    list-style: none;
}

li.page-item.active a {
    background-color: #aaa !important;
}

.pager li a {
    display: block;
    font-size: 16px;
    padding: 0.6em 1em;
    border-radius: 3px;
    background: #eee;
    color: #000;
    text-decoration: none;
    list-style: none;
}

.pager li a:hover {
    background: #333;
    color: #fff;
}

.slide-enter-active,
.slide-leave-active {
    transition: opacity 0.3s;
}

.slide-enter,
.slide-leave {
    opacity: 0;
}

/*
        .slide-leave-active {
            transition: s ;
        }
        .slide-leave{
             z-index: 0;
            opacity: 0;
        }
        .slide-leave-to{
             z-index: 0;
            opacity: 1;
        }
    */

/*
        .slide-enter-active {
            transition: transform 3000ms ease-out;
        }
        .slide-enter {
            opacity: 0;
            z-index: 1;
            transform: translateY(500px);
        }
        
        .slide-enter-to {
            z-index: 1;
            transform: translateY(0px);
            opacity: 1; 
        }
        */
.times-new-roman {
    font-family: "Times New Roman";
}
</style>

<script>
    // @ is an alias to /src
    //import HelloWorld from '@/components/HelloWorld.vue'
    import store from "../store";
    import {
        API_URL,
        CONTENTS_SRV
    } from "@/services/config";
    
    export default {
        name: "search",
        components: {
            // HelloWorld
            /*
            wordData(){
                  return this.$store.getters.wordData;
            }
            */
        },
        computed: {
            isDispParts() {
                var self = this
                return function(meaning) {
                    var newPart = `${meaning.vid}/${meaning.partname}/${meaning.subpartname}`
                    var ret = true
                    if (newPart == self.oldPart) {
                        ret = false
                    }
                    self.oldPart = newPart
                    return ret
                }
            },
            isSearchLeft() {
                return this.$store.getters.isSearchLeft;
            },
            isCompView() {
                return this.$store.getters.isCompView;
            },
            isSearchBox() {
                return this.$store.getters.isSearchBox;
            },
            jpListData() {
                return this.$store.getters.jpListData.list;
            },
            jpSearchWord() {
                return this.$store.getters.jpListData.keyWord;
            },
            selectVid() {
                return this.$store.getters.selectVid;
            },
            isSelectVid() {
                return  function(vid) {
                    return vid === this.$store.getters.selectVid;
                }
            },
            wordData() {
                return this.$store.getters.wordData;
            },
            isListTypeJp() {
                if (this.$store.getters.listType == "1") return true;
                else return false;
            },
            isListTypeRy() {
                if (this.$store.getters.listType == "2") return true;
                else return false;
            },
            isWide() {
                return this.$store.getters.isWide;
            },
            pageCurrentNo() {
                return this.$store.getters.pageCurrentNo;
            },
            pageAllCnt() {
                return this.$store.getters.pageAllCnt;
            },
            allCnt() {
                return this.$store.getters.allCnt;
            },
            getMessage() {
                return this.$store.getters.errMessage;
            },
            isMessage() {
                if (this.$store.getters.errMessage == "") return true;
                else return false;
            }
        },
        data() {
            return {
                /* pagination */
                currentPage: 5,
                total: 9,
    
                /* おじーのアイコン */
                ojiImage: require("../assets/img/illust-oji-close.png"),
                ojiImageoff: require("../assets/img/illust-oji-off.png"),
                ojiImageClose: require("../assets/img/illust-oji-close.png"),
                ojiImagePlay: require("../assets/img/illust-oji-play.gif"),
    
                /* おばーのアイコン */
                obaImage: require("../assets/img/illust-oba-close.png"),
                obaImageClose: require("../assets/img/illust-oba-close.png"),
                obaImageoff: require("../assets/img/illust-oba-off.png"),
                obaImagePlay: require("../assets/img/illust-oba-play.gif"),
    
                dicshotname: "",
                word2: "test",
                main: [],
                loading: true,
                topmenu1: [{
                    title: "琉球語概説"
                }, {
                    title: "プロジェクト概要"
                }],
                topmenu2: [{
                        title: "今帰仁"
                    },
                    {
                        title: "首里那覇"
                    },
                    {
                        title: "奄美"
                    },
                    {
                        title: "宮古下里"
                    },
                    {
                        title: "与論"
                    },
                    {
                        title: "伊是名"
                    }
                ],
                oldPart: '',
                compData: [],
                ipath: ''
            };
        },
        mounted: function() {},
        beforeRouteUpdate(to, from, next) {
            console.log("beforeRouteUpdate");
            if (to.name === "detail") {
                //       if(store.getters.selectVid !==to.params.vid )
                //           this.getDetail(to.params.vid);
                this.getDetail(to.params.vid);
            } else if (to.name === "jdetail") {
                this.getWordDetail(to.params.sid);
            }
            next();
        },
        beforeRouteEnter(to, from, next) {
            console.log("beforeRouteEnter");
            if (to.name === "detail") {
                store.dispatch("upSelectVid", "123");
                //var a = store.getters.selectVid;
                // if(store.getters.selectVid !==to.params.vid )
                //   this.getDetail(to.params.vid);
                next(vm => vm.getDetail(to.params.vid));
            } else if (to.name === "jdetail") {
                next(vm => vm.getWordDetail(to.params.sid));
            } else {
                next();
            }
        },
        methods: {
            isWordBold(word) {
                    return ( word === this.$store.getters.selListData.word_kanji || word === this.$store.getters.selListData.word_kana);
                        
            },

            dispMean(meaning, index) {
                if (index == 0)
                    return true
    
                var newPart = `${meaning.vid}/${meaning.partname}/${meaning.subpartname}`
                var ret = true
                if (newPart == self.oldPart) {
                    ret = false
                }
                self.oldPart = newPart
                return ret
            },
            cb(val) {
                var self = this;
                self.$store.dispatch("upPageNo", val);
            },
            ojiPlay() {
                this.ojiImage = this.ojiImagePlay;
            },
            ojiClose() {
                this.ojiImage = this.ojiImageClose;
            },
            obaPlay() {
                this.obaImage = this.obaImagePlay;
            },
            obaClose() {
                this.obaImage = this.obaImageClose;
            },
            soundPlay(sound) {
                var audio = new Audio(sound);
                audio.play();
            },
            getDetail(vid) {
                var self = this;
                var params = new URLSearchParams();
                params.append("vid", vid);
                self.$axios.post(`${API_URL}/search/getdetail`, params).then(res => {
                    self.$store.dispatch("upWordData", res.data);
                    self.$store.dispatch("upSelectVid", vid);
                    self.$store.dispatch('upIsGuide', false);
                });
            },
            getWordDetail(sid) {
                var self = this;
                var params = new URLSearchParams();
                params.append("sid", sid);
                self.$axios.post(`${API_URL}/search/getworddetail`, params).then(res => {
                    self.$store.dispatch("upWordData", res.data);
                    self.$store.dispatch("upSelectVid", sid);
                    self.$store.dispatch('upIsGuide', false);
                });
            },
            /**
             * 詳細の幅
             */
            chgWide() {
                var self = this;
                self.$store.dispatch("upIsWide", !self.isWide);
            },
            clickItem(item) {
                var self = this;
                if(self.isSearchLeft===true){
                   self.$store.dispatch("upIsSearchBox", false); //!this.$store.getters.isSearchBox);
                }

                self.$store.dispatch("upErrMessage", "");
                self.$store.dispatch("upSelListData",item);

                self.$router.push({
                    path: `/detail/${item.vid}`
                });

                var params = new URLSearchParams();
                params.append("vid", item.vid);
                console.log("getImg");
                self.$axios.post(`${API_URL}/search/getImg`, params).then(res => {
                    self.ipath = res.data.ipath === '' ? require("../assets/img/no-image.jpg") : `${CONTENTS_SRV}/${res.data.ipath}`;
                })
            },
            clickItemJ(item) {
                var self = this;
                if(self.isSearchLeft===true){
                   self.$store.dispatch("upIsSearchBox", false); //!this.$store.getters.isSearchBox);
                }
                self.$store.dispatch("upErrMessage", "");
                self.$store.dispatch("upSelListData",item);
                self.$router.push({
                    path: `/jdetail/${item.stwordid}`
                });

                var params = new URLSearchParams();
                params.append("vid", item.vid);
                console.log("getImg J");
                self.$axios.post(`${API_URL}/search/getImg`, params).then(res => {
                    self.ipath = res.data.ipath === '' ? require("../assets/img/no-image.jpg") : `${CONTENTS_SRV}/${res.data.ipath}`;
                })
            },
            clickComp(vid) {
                var self = this;
                var params = new URLSearchParams();
                params.append("vid", vid);
                self.$axios.post(`${API_URL}/search/getdetail`, params).then(res => {
                    self.$store.dispatch("upCompData", res.data);
                    self.$store.dispatch("upIsCompView", true);
                });
                self.$axios.post(`${API_URL}/search/getImg`, params).then(res => {
                    self.ipath = res.data.ipath === '' ? require("../assets/img/no-image.jpg") : `${CONTENTS_SRV}/${res.data.ipath}`;
                });
            }
        }
    };
</script>
